/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} SubscriptionInputs */

const en_subscription = /** @type {(inputs: SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription`)
};

const de_subscription = /** @type {(inputs: SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement`)
};

/**
* | output |
* | --- |
* | "Subscription" |
*
* @param {SubscriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const subscription = /** @type {((inputs?: SubscriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SubscriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription(inputs)
	return de_subscription(inputs)
});